import $ from '../core/Dom';
import EcoMode from '../lib/EcoMode';

export default (el, props) => {
    const $el = $(el);
    
    const init = () => {
        $el.on('click', '[data-mode-button]', e => {
            e.preventDefault();
            const $toggle = $(e.triggerTarget);
            EcoMode.setPrefs({ ecoMode: $toggle.data('mode-button') === 'eco' ? 'on' : 'off' });
            disablePopup();
            closePopup();
        });
        
        $el.on('click', 'a', e => {
            disablePopup();
        });
    };

    const destroy = () => {
        $el.off('click');
    };
    
    const disablePopup = () => {
        localStorage.ecoModePopupShown = 'yes';
    };
    
    const closePopup = () => {
        $el.css({ display: 'none' });
    };

    return {
        init,
        destroy
    };
};
